import { useState } from 'react';
import { Pause, Play } from 'lucide-react';
import { ConfirmacaoModal } from './ConfirmacaoModal';

interface BotaoSegurancaProps {
  conversasAtivas: number;
  onPausarTudo: () => void;
  onLigarTudo: () => void;
  modoManualAtivo: boolean;
}

export function BotaoSeguranca({ conversasAtivas, onPausarTudo, onLigarTudo, modoManualAtivo }: BotaoSegurancaProps) {
  const [showModal, setShowModal] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  const handleClick = () => {
    setShowModal(true);
  };

  return (
    <>
      {/* FAB */}
      <div className="fixed bottom-6 right-6 z-40">
        <button
          onClick={handleClick}
          onMouseEnter={() => setIsExpanded(true)}
          onMouseLeave={() => setIsExpanded(false)}
          className={`
            flex items-center gap-2 rounded-full shadow-2xl transition-all duration-300
            ${modoManualAtivo
              ? 'bg-ds-success hover:bg-ds-success/90 shadow-ds-success/20'
              : 'bg-ds-danger hover:bg-ds-danger/90 shadow-ds-danger/20'
            }
            ${isExpanded ? 'px-5 py-3' : 'w-14 h-14 justify-center'}
          `}
        >
          {modoManualAtivo ? (
            <Play className="h-6 w-6 text-white" />
          ) : (
            <Pause className="h-6 w-6 text-white" />
          )}
          {isExpanded && (
            <span className="text-white font-medium text-sm whitespace-nowrap">
              {modoManualAtivo ? 'Ligar IA Geral' : 'Pausar IA Geral'}
            </span>
          )}
        </button>
      </div>

      {/* Modal de confirmação */}
      <ConfirmacaoModal
        isOpen={showModal}
        title={modoManualAtivo ? 'Ligar IA em todas as conversas?' : 'Pausar IA em todas as conversas?'}
        message={
          modoManualAtivo
            ? 'A IA voltará a responder automaticamente em todas as conversas. Certifique-se de que os atendentes humanos terminaram seus atendimentos.'
            : `Isso desligará a IA em ${conversasAtivas} conversa(s) ativa(s). Todas serão transferidas para atendimento humano imediato.`
        }
        confirmText={modoManualAtivo ? 'Sim, Ligar Tudo' : 'Sim, Pausar Tudo'}
        cancelText="Cancelar"
        variant={modoManualAtivo ? 'primary' : 'danger'}
        onConfirm={() => {
          if (modoManualAtivo) {
            onLigarTudo();
          } else {
            onPausarTudo();
          }
          setShowModal(false);
        }}
        onCancel={() => setShowModal(false)}
      />
    </>
  );
}
